export class ResourceUtils {

  static getQueryStringParam(name: string): string {
    if (window && window.location && window.location.search) {
      const queryString = window.location.search;
      const regexp = new RegExp(name + '=([^&]+)');
      const result = regexp.exec(queryString);
      if (result == null || result.length < 1) {
        return null;
      }
      const match = result[1];
      const decodedValue = decodeURIComponent(match);
      return decodedValue;
    } else {
      return null;
    }
  }


}


